module.exports = __webpack_public_path__ + "static/media/total-entradas-icon.735e95f1.svg";